/* FunBug: reads the review data Judge.me already puts on the page, so review cards fill in automatically for every product.
   2026-10-21: FBReviews.strip() builds the swipeable review strip (square photos first, then text reviews) and the tap-to-enlarge photo viewer. */
(function () {
  if (window.FBReviews) return;
  var cache = null;
  /* 2026-10-21: reads the review data the theme writes into the page (snippet fb-review-data, from the product's Judge.me field) first,
     so nothing waits on Judge.me's script. Falls back to the data Judge.me's own widget adds to the page. */
  function readList(el, attr) {
    if (!el) return [];
    try { var l = JSON.parse(el.getAttribute(attr) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function parse() {
    var src = document.querySelector('[data-fb-rev-src]');
    var raw = readList(src, 'data-gallery').concat(readList(src, 'data-text'));
    if (!raw.length) raw = readList(document.querySelector('.jdgm-gallery-data'), 'data-json');
    if (!raw.length) return null;
    var dp = new DOMParser();
    var plain = function (h) { return dp.parseFromString(h || '', 'text/html').body.textContent.trim(); };
    var out = raw.map(function (r) {
      var pic = '';
      if (r.pictures_urls && r.pictures_urls[0]) pic = r.pictures_urls[0].compact || r.pictures_urls[0].original || '';
      if (pic) pic = pic.replace('width=160', 'width=600');
      return { name: plain(r.reviewer_name), rating: Number(r.rating) || 5, text: plain(r.body_html), pic: pic, date: r.created_at || '' };
    }).filter(function (r) { return r.text; });
    out.sort(function (a, b) { return a.date < b.date ? 1 : -1; });
    return out;
  }
  /* Judge.me can add its review data late (slow first visit, nothing cached yet). Rather than giving up after a few seconds, wait until the data appears on the page, then fill every waiting strip. */
  var waiting = [], watching = false;
  function ready(cb) {
    var list = cache || parse();
    if (list) { cache = list; cb(list); return; }
    waiting.push(cb);
    if (watching) return;
    watching = true;
    var mo = null, iv = null;
    function check() {
      if (cache || !document.querySelector('.jdgm-gallery-data')) return;
      var l = parse();
      if (!l) return;
      cache = l;
      if (mo) mo.disconnect();
      clearInterval(iv);
      var w = waiting; waiting = [];
      w.forEach(function (f) { f(l); });
    }
    if ('MutationObserver' in window) {
      mo = new MutationObserver(check);
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
    iv = setInterval(check, 1000);
    setTimeout(function () { clearInterval(iv); }, 120000);
    window.addEventListener('load', check);
  }
  function stars(n, size) {
    var s = '';
    for (var i = 1; i <= 5; i++) {
      s += '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3 6.1 20.6l1.3-6.6L2.5 9.4l6.6-.8z" fill="' + (i <= n ? '#f4b314' : '#dce2ea') + '"/></svg>';
    }
    return s;
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function attr(t) { return esc(t).replace(/"/g, '&quot;'); }
  function sized(url, w) { return url.indexOf('width=') > -1 ? url.replace(/width=\d+/, 'width=' + w) : url; }
  var ICON = {
    prev: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>',
    next: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>',
    close: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    zoom: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M11 8v6M8 11h6"/></svg>'
  };

  /* full-screen photo viewer, swipe between photos */
  function viewer(mount, photos) {
    var lb = document.createElement('div');
    lb.className = 'fb-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Customer photos');
    lb.innerHTML = '<div class="fb-lb__top"><span class="fb-lb__count"></span><button type="button" class="fb-lb__close" aria-label="Close photos">' + ICON.close + '</button></div>' +
      '<div class="fb-lb__track">' + photos.map(function (r) {
        return '<figure class="fb-lb__slide"><img data-src="' + attr(sized(r.pic, 1080)) + '" alt="Photo from ' + attr(r.name) + '"><figcaption class="fb-lb__cap"><div class="fb-stars">' + stars(r.rating, 14) + '</div><p>' + esc(r.text) + '</p><b>' + esc(r.name) + '</b></figcaption></figure>';
      }).join('') + '</div>' +
      '<button type="button" class="fb-lb__arrow fb-lb__arrow--prev" aria-label="Previous photo">' + ICON.prev + '</button>' +
      '<button type="button" class="fb-lb__arrow fb-lb__arrow--next" aria-label="Next photo">' + ICON.next + '</button>';
    mount.appendChild(lb);
    var track = lb.querySelector('.fb-lb__track');
    var count = lb.querySelector('.fb-lb__count');
    var closeBtn = lb.querySelector('.fb-lb__close');
    var pBtn = lb.querySelector('.fb-lb__arrow--prev');
    var nBtn = lb.querySelector('.fb-lb__arrow--next');
    var imgs = track.querySelectorAll('img');
    var last = null;
    function idx() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function load(i) { var im = imgs[i]; if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-src'); }
    function upd() {
      var i = idx();
      load(i); load(i + 1); load(i - 1);
      count.textContent = (i + 1) + ' / ' + photos.length;
      pBtn.disabled = i <= 0;
      nBtn.disabled = i >= photos.length - 1;
    }
    function go(i) { i = Math.max(0, Math.min(photos.length - 1, i)); track.scrollTo({ left: i * track.clientWidth }); }
    function close() {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      if (last) last.focus();
    }
    track.addEventListener('scroll', upd, { passive: true });
    pBtn.addEventListener('click', function () { go(idx() - 1); });
    nBtn.addEventListener('click', function () { go(idx() + 1); });
    closeBtn.addEventListener('click', close);
    track.addEventListener('click', function (e) { if (e.target === track || e.target.classList.contains('fb-lb__slide')) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(idx() + 1);
      else if (e.key === 'ArrowLeft') go(idx() - 1);
    });
    return function open(i, btn) {
      last = btn || null;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = i * track.clientWidth;
      track.style.scrollBehavior = '';
      upd();
      closeBtn.focus();
    };
  }

  /* swipeable review strip: host needs [data-strip-row], and optionally [data-strip-nav] with [data-prev], [data-next] and an <i> progress bar */
  function strip(host, opts) {
    opts = opts || {};
    var max = opts.max || 6;
    var row = host.querySelector('[data-strip-row]');
    var nav = host.querySelector('[data-strip-nav]');
    if (!row) return;
    ready(function (list) {
      var pool = list.filter(function (r) { return r.text.length >= 20 && r.rating >= 4; });
      pool.sort(function (a, b) { return (b.pic ? 1 : 0) - (a.pic ? 1 : 0) || (a.date < b.date ? 1 : -1); });
      var pick = pool.slice(0, max);
      if (!pick.length) return;
      var photos = [];
      var html = '';
      pick.forEach(function (r) {
        var top = '';
        if (r.pic) {
          top = '<button type="button" class="fb-rcard__pic" data-pi="' + photos.length + '" aria-label="View photo from ' + attr(r.name) + '"><img src="' + attr(sized(r.pic, 400)) + '" alt="Photo from ' + attr(r.name) + '" width="400" height="400" loading="lazy" decoding="async"><span class="fb-rcard__zoom">' + ICON.zoom + '</span></button>';
          photos.push(r);
        }
        html += '<div class="fb-rcard' + (r.pic ? '' : ' fb-rcard--text') + '">' + top + '<div class="fb-rcard__body"><div class="fb-stars">' + stars(r.rating, 13) + '</div><p>' + esc(r.text) + '</p><b>' + esc(r.name) + '</b></div></div>';
      });
      row.innerHTML = html;
      host.hidden = false;

      if (nav) {
        var bar = nav.querySelector('i');
        var prev = nav.querySelector('[data-prev]');
        var next = nav.querySelector('[data-next]');
        var step = function () { var c = row.firstElementChild; return c ? c.getBoundingClientRect().width + 12 : row.clientWidth; };
        var sync = function () {
          var maxS = row.scrollWidth - row.clientWidth;
          nav.hidden = maxS <= 2;
          if (nav.hidden) return;
          if (bar) {
            bar.style.width = (row.clientWidth / row.scrollWidth * 100) + '%';
            bar.style.left = (row.scrollLeft / row.scrollWidth * 100) + '%';
          }
          if (prev) prev.disabled = row.scrollLeft <= 2;
          if (next) next.disabled = row.scrollLeft >= maxS - 2;
        };
        row.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step() }); });
        if (next) next.addEventListener('click', function () { row.scrollBy({ left: step() }); });
        sync();
      }

      if (!photos.length) return;
      var open = viewer(host.closest('.fbp') || document.body, photos);
      row.addEventListener('click', function (e) {
        var b = e.target.closest('.fb-rcard__pic');
        if (b) open(Number(b.getAttribute('data-pi')), b);
      });
    });
  }

  window.FBReviews = { ready: ready, stars: stars, esc: esc, strip: strip };
})();
